import { Controller } from "@hotwired/stimulus";

// Self-filling Locals hero slideshow: drop
// <div data-controller="locals-showcase"></div> anywhere (e.g. a CMS page) and it
// pulls in the server-rendered Bootstrap carousel of profile hero images from
// /showcase. The endpoint re-samples on every request, so each load is fresh.
//
// Because the carousel markup is injected after page load, its `data-bs-ride`
// auto-init (which only runs for markup present at load) won't fire — so we
// initialise it explicitly via the bundled Bootstrap (window.bootstrap). No
// external libraries.
export default class extends Controller {
  static values = {
    url: { type: String, default: "/showcase" },
    interval: { type: Number, default: 4000 },
  };

  connect() {
    fetch(this.urlValue, {
      headers: { "X-Requested-With": "XMLHttpRequest" },
      credentials: "same-origin",
    })
      .then((response) => (response.ok ? response.text() : Promise.reject(response.status)))
      .then((html) => {
        this.element.innerHTML = html;
        const el = this.element.querySelector(".carousel");
        if (el && window.bootstrap) {
          window.bootstrap.Carousel.getOrCreateInstance(el, {
            interval: this.intervalValue,
            ride: "carousel",
          });
        }
      })
      .catch(() => {
        /* leave the container empty on failure */
      });
  }
}
